<template>
  <v-app>
    <v-main >
      <LSIMensajes />
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>

import LSIMensajes from 'vue-lsi-util'

import store from './store'

export default {
  name: 'App',

  components: {
    LSIMensajes 
  },

  data: () => ({
    //
  }),

  methods: {
    alertDialogOcultar(cualBotonApretado) {
      store.dispatch("alertDialog/ocultar", cualBotonApretado)
    }
  },

  computed: {
    textoAMostrar() {
      return store.state.snackbar.textoAMostrar
    },
    cartelAMostrar() {
      return store.state.loading.cartelAMostrar
    },
    TituloMenuPrincipal() {
      return this.TituloPrincipal
    },
    alertDialog() {
      return store.state.alertDialog.textoAMostrar
    }
  },

  created() {
    axios.defaults.baseURL="https://apiv2.area54sa.com.ar:8123/apiv2/"
  },
  
  watch: {
    '$route' (to, from) {
      document.title = to.meta.tituloPagina || 'Area 54'
    }
  }
}

</script>
<style>
.app-gradient {
  background: linear-gradient(180deg, #9E9E9E 0%, rgba(218, 218, 218, 0.355488) 45.1%, rgba(158, 158, 158, 0) 100%);
}
</style>
